/* esm.sh - unhead@3.1.0/dist/shared/unhead.A4ndrqqe */
export * from "/*unhead@3.1.0/esnext/dist/shared/unhead.A4ndrqqe.mjs";
